(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MQ='(max-width:880px)';

  function init(root){
    if(root.dataset.eeBarInit) return;
    root.dataset.eeBarInit='1';

    var viewport=root.querySelector('.ee-bar__viewport');
    var track=root.querySelector('.ee-bar__track');
    var group=root.querySelector('.ee-bar__group');
    if(!viewport||!track||!group) return;

    var mq=window.matchMedia(MQ);
    var modeD=root.getAttribute('data-mode-desktop')||'fade';
    var modeM=root.getAttribute('data-mode-mobile')||modeD;
    var stickyD=root.getAttribute('data-sticky-d')==='1';
    var stickyM=root.getAttribute('data-sticky-m')==='1';
    var offsetOn=root.getAttribute('data-offset-header')==='1';
    var wrap=root.closest('.shopify-section')||root.parentElement;

    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer=null, paused=false, idx=0;

    function items(){ return group.querySelectorAll('.ee-bar__item'); }
    function show(i){
      var list=items(); if(!list.length) return;
      idx=((i%list.length)+list.length)%list.length;
      list.forEach(function(it,k){ it.classList.toggle('is-active',k===idx); });
    }

    // --- zanikanie ---
    function startFade(){
      stopMarquee();
      root.classList.add('ee-bar--fading');
      show(idx);
      clearInterval(timer); timer=null;
      if(items().length<2) return;
      var ms=Math.max(2,parseFloat(root.getAttribute('data-interval'))||4)*1000;
      timer=setInterval(function(){ if(!paused) show(idx+1); },ms);
    }
    function stopFade(){
      clearInterval(timer); timer=null;
      root.classList.remove('ee-bar--fading');
    }

    // --- przesuwanie ---
    function stopMarquee(){
      root.classList.remove('ee-bar--running');
      track.querySelectorAll('.ee-bar__group--clone').forEach(function(c){ c.remove(); });
    }
    function startMarquee(){
      stopFade();
      stopMarquee();
      var gw=group.scrollWidth;
      if(!gw) return;
      var need=viewport.clientWidth*2+gw, guard=0;
      while(track.scrollWidth<need && guard<20){
        var c=group.cloneNode(true);
        c.classList.add('ee-bar__group--clone');
        c.setAttribute('aria-hidden','true');
        c.querySelectorAll('a').forEach(function(a){ a.setAttribute('tabindex','-1'); });
        track.appendChild(c);
        guard++;
      }
      var speed=Math.max(10,parseFloat(root.getAttribute('data-speed'))||50);
      track.style.setProperty('--ee-bar-shift',(-gw)+'px');
      track.style.setProperty('--ee-bar-dur',(gw/speed)+'s');
      root.classList.add('ee-bar--running');
    }

    function currentMode(){ return mq.matches ? modeM : modeD; }
    function setModeClass(m){
      ['fade','marquee','static'].forEach(function(x){ root.classList.remove('ee-bar--'+x); });
      root.classList.add('ee-bar--'+m);
    }
    function fitsInRow(){ return group.scrollWidth<=viewport.clientWidth+2; }

    function layout(){
      var mode=currentMode();
      stopMarquee(); stopFade();
      setModeClass(mode);
      if(root.offsetParent===null){ return; } // pasek ukryty na tym urządzeniu
      if(mode==='marquee'){
        if(reduceMotion){ startFade(); } else { startMarquee(); }
      }else if(mode==='fade'){
        startFade();
      }else if(!fitsInRow()){
        startFade(); // static, ale się nie mieści
      }
    }

    // --- przyklejenie ---
    // Pasek sprawdza, co faktycznie zasłania górną krawędź ekranu (niezależnie od tego,
    // gdzie motyw ma menu w kodzie strony). Jeśli jest tam przyklejone/fixed menu,
    // pasek ustawia się tuż pod jego dolną krawędzią. Działa też dla menu, które
    // pojawia się dopiero przy przewijaniu i wysuwa się z animacją.
    function isStickyNow(){ return mq.matches ? stickyM : stickyD; }

    function topObstacle(){
      var best=0, z=null, seen=[];
      var w=window.innerWidth;
      [8, Math.round(w/2), w-8].forEach(function(x){
        var els=document.elementsFromPoint ? document.elementsFromPoint(x,1) : [];
        els.forEach(function(el){
          var c=el;
          while(c && c!==document.body && c!==document.documentElement){
            if(wrap.contains(c) || c.contains(wrap)) return;   // nasz pasek
            if(seen.indexOf(c)!==-1) return;
            var cs=getComputedStyle(c);
            if(cs.position==='fixed' || cs.position==='sticky'){
              seen.push(c);
              if(cs.display==='none' || cs.visibility==='hidden' || parseFloat(cs.opacity)===0) return;
              var r=c.getBoundingClientRect();
              if(!r.height || r.height>window.innerHeight*0.5) return; // szuflady, nakładki
              if(r.bottom<=0) return;                                  // schowane nad ekranem
              if(r.top>(parseFloat(cs.top)||0)+4) return;              // jeszcze nie przyklejone
              if(r.bottom>best){ best=r.bottom; z=cs.zIndex; }
              return;
            }
            c=c.parentElement;
          }
        });
      });
      return { bottom:Math.max(0,Math.round(best)), z:z };
    }

    // Niewidoczny znacznik tuż przed paskiem = naturalne miejsce paska na stronie.
    var sentinel=wrap.previousElementSibling;
    if(!sentinel || !sentinel.classList.contains('ee-bar-sentinel')){
      sentinel=document.createElement('div');
      sentinel.className='ee-bar-sentinel';
      sentinel.setAttribute('aria-hidden','true');
      sentinel.style.cssText='height:0;margin:0;padding:0;border:0';
      if(wrap.parentNode) wrap.parentNode.insertBefore(sentinel,wrap);
    }

    function unstick(){
      wrap.classList.remove('ee-bar-stuck');
      wrap.style.removeProperty('--ee-bar-top');
      wrap.style.removeProperty('--ee-bar-z');
      document.documentElement.style.setProperty('--ee-bar-sticky-h','0px');
    }

    function applySticky(){
      if(!isStickyNow() || root.offsetParent===null){ unstick(); return; }
      var info=offsetOn ? topObstacle() : { bottom:0, z:null };
      var target=info.bottom;
      // przyklejamy dopiero, gdy pasek dojechał do krawędzi (lub do dolnej krawędzi menu)
      var natural=sentinel.getBoundingClientRect().top;
      if(natural>target+0.5){ unstick(); return; }

      wrap.classList.add('ee-bar-stuck');
      var val=target+'px';
      if(wrap.style.getPropertyValue('--ee-bar-top')!==val) wrap.style.setProperty('--ee-bar-top',val);
      // pod menu: warstwa niżej niż menu, żeby rozwijane podmenu było nad paskiem
      var zi=parseInt(info.z,10);
      wrap.style.setProperty('--ee-bar-z', target>0 ? (isNaN(zi) ? '2' : String(Math.max(1,zi-1))) : '40');
      document.documentElement.style.setProperty('--ee-bar-sticky-h',(target+Math.round(wrap.getBoundingClientRect().height))+'px');
    }

    // Po każdym przewinięciu liczymy na bieżąco przez ~0,7 s (każda klatka),
    // żeby pasek płynnie podążał za wysuwającym się / chowającym menu.
    var loopUntil=0, looping=false;
    function kick(){
      loopUntil=Date.now()+700;
      if(looping) return;
      looping=true;
      (function step(){
        applySticky();
        if(Date.now()<loopUntil){ requestAnimationFrame(step); } else { looping=false; }
      })();
    }
    if(stickyD || stickyM){ window.addEventListener('scroll',kick,{passive:true}); }

    function relayout(){ layout(); kick(); }

    // pauza po najechaniu / fokusie
    function setPaused(v){ paused=v; root.classList.toggle('is-paused',v); }
    root.addEventListener('mouseenter',function(){ setPaused(true); });
    root.addEventListener('mouseleave',function(){ setPaused(false); });
    root.addEventListener('focusin',function(){ setPaused(true); });
    root.addEventListener('focusout',function(){ setPaused(false); });

    var rt;
    window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(relayout,200); });
    if(mq.addEventListener){ mq.addEventListener('change',relayout); } else if(mq.addListener){ mq.addListener(relayout); }

    // edytor motywu: zaznaczenie bloku pokazuje ten komunikat
    root.addEventListener('shopify:block:select',function(e){
      var list=Array.prototype.slice.call(items());
      var k=list.indexOf(e.target);
      setPaused(true);
      if(k!==-1 && root.classList.contains('ee-bar--fading')) show(k);
    });
    root.addEventListener('shopify:block:deselect',function(){ setPaused(false); });

    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(relayout); } else { relayout(); }
    setTimeout(kick,600); // motywy często inicjalizują sticky menu z opóźnieniem
  }

  function initAll(){ document.querySelectorAll('.ee-bar').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('ee-cd');
  if(!root) return;
  var overlay=document.getElementById('ee-cd-overlay');
  var panel=root.querySelector('.ee-cd__panel');
  var itemsEl=document.getElementById('ee-cd-items');
  var emptyEl=document.getElementById('ee-cd-empty');
  var footEl=document.getElementById('ee-cd-foot');
  var countEl=document.getElementById('ee-cd-count');
  var subtotalEl=document.getElementById('ee-cd-subtotal');
  var shipMsg=document.getElementById('ee-cd-ship-msg');
  var shipFill=document.getElementById('ee-cd-ship-fill');
  var errorEl=document.getElementById('ee-cd-error');
  var threshold=parseInt(root.getAttribute('data-threshold'),10)||0; // w jednostkach waluty (nie w groszach)
  var thresholdCents=threshold*100;
  var iconSelector=root.getAttribute('data-cart-icon-selector')||'';

  // --- adresy koszyka z Liquid (routes.*) — bezpieczne dla Markets / prefiksów językowych ---
  var URL_CART   =(root.getAttribute('data-url-cart')||'/cart')+'.js';
  var URL_ADD    =(root.getAttribute('data-url-add')||'/cart/add')+'.js';
  var URL_CHANGE =(root.getAttribute('data-url-change')||'/cart/change')+'.js';
  var MONEY_FORMAT=root.getAttribute('data-money-format')||'';
  var MSG_ERROR   =root.getAttribute('data-msg-error')||'Could not add item to cart.';
  var MSG_REACHED_NOTE=root.getAttribute('data-msg-reached-note')||'';
  // brak klucza w tłumaczeniach: Shopify zwraca "translation missing: ...", wtedy używamy tekstu zapasowego
  function i18n(attr,fallback){ var v=root.getAttribute(attr)||''; return (!v || v.indexOf('translation missing')===0)?fallback:v; }
  var MSG_BLOCKED=i18n('data-msg-blocked','Free shipping does not apply to this order');
  var MSG_BLOCKED_NOTE=i18n('data-msg-blocked-note','A product in your cart has higher shipping costs.');
  var SHIP_MAX=parseFloat(String(root.getAttribute('data-ship-max')||'0').replace(',','.'))||0;
  var shipMap={};   // product_id -> koszt dostawy (z metapola), odświeżane z HTML sekcji
  function readShipMap(scope){
    var el=(scope||document).querySelector('#ee-cd-shipmap');
    if(!el) return;
    try{ shipMap=JSON.parse(el.textContent||'{}')||{}; }catch(e){}
  }
  // Jeśli w koszyku jest choć jeden produkt, którego dostawa (metapole) jest droższa niż limit,
  // nie obiecujemy darmowej wysyłki ani nie pokazujemy licznika do progu. Taki produkt
  // (np. stolik) podnosi koszt dostawy całego zamówienia, także przy kilku sztukach.
  // Świadomy kompromis: produkt tuż nad limitem w dużym koszyku może w SST wyjść taniej,
  // wtedy klient w kasie zobaczy darmową wysyłkę mimo komunikatu. To bezpieczniejszy błąd
  // niż obiecanie darmowej wysyłki, której nie będzie.
  function shipBlocked(cart){
    if(!SHIP_MAX || !cart || !cart.items) return false;
    for(var i=0;i<cart.items.length;i++){
      var c=shipMap[String(cart.items[i].product_id)];
      if(typeof c==='number' && c>SHIP_MAX) return true;
    }
    return false;
  }
  var lastCart=null;
  readShipMap(document);

  // --- etykiety i18n (wszystkie konfigurowalne w ustawieniach sekcji) ---
  var LBL_REMOVE  =root.getAttribute('data-lbl-remove')||'Remove';
  var LBL_LESS    =root.getAttribute('data-lbl-less')||'Less';
  var LBL_MORE    =root.getAttribute('data-lbl-more')||'More';
  var LBL_FREESHIP=root.getAttribute('data-lbl-freeship')||'= free shipping';

  // --- format ceny wg shop.money_format (ten sam wynik co filtr `money` w Liquid) ---
  function money(cents){
    var f=MONEY_FORMAT;
    if(!f){
      var cur=root.getAttribute('data-currency')||'';
      return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})+' '+cur;
    }
    var re=/\{\{\s*(\w+)\s*\}\}/;
    function withDelims(number, precision, thousands, decimal){
      thousands=(thousands==null)?',':thousands;
      decimal=(decimal==null)?'.':decimal;
      precision=(precision==null)?2:precision;
      if(isNaN(number)||number==null) return '0';
      var n=(number/100).toFixed(precision).split('.');
      var main=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands);
      return main+(n[1]?decimal+n[1]:'');
    }
    var m=f.match(re);
    if(!m) return f;
    var v='';
    switch(m[1]){
      case 'amount':                                  v=withDelims(cents,2); break;
      case 'amount_no_decimals':                      v=withDelims(cents,0); break;
      case 'amount_with_comma_separator':             v=withDelims(cents,2,'.',','); break;
      case 'amount_no_decimals_with_comma_separator': v=withDelims(cents,0,'.',','); break;
      case 'amount_with_apostrophe_separator':        v=withDelims(cents,2,"'",'.'); break;
      case 'amount_with_space_separator':             v=withDelims(cents,2,' ',','); break;
      case 'amount_no_decimals_with_space_separator': v=withDelims(cents,0,' ',','); break;
      default:                                        v=withDelims(cents,2);
    }
    return f.replace(re,v);
  }

  // --- escapowanie treści wstawianej przez innerHTML (tytuły z & lub < ) ---
  function esc(s){
    return String(s==null?'':s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // --- komunikat błędu w panelu ---
  var errTimer=null;
  function showError(msg){
    if(!errorEl) return;
    errorEl.textContent=msg||MSG_ERROR;
    errorEl.removeAttribute('hidden');
    if(errTimer) clearTimeout(errTimer);
    errTimer=setTimeout(clearError, 8000);
  }
  function clearError(){ if(errorEl){ errorEl.setAttribute('hidden',''); errorEl.textContent=''; } }

  // --- wspólna konfiguracja dla innych sekcji (np. pasek darmowej wysyłki na stronie produktu) ---
  window.EE_CART_DRAWER={ thresholdCents:thresholdCents, moneyFormat:MONEY_FORMAT, open:function(){}, refresh:function(){} };

  // --- otwieranie / zamykanie ---
  var lastFocus=null;
  function open(){
    lastFocus=document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    var c=document.getElementById('ee-cd-close'); if(c) c.focus();
  }
  function close(){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
    clearError();
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  overlay.addEventListener('click',close);
  var closeBtn=document.getElementById('ee-cd-close');
  if(closeBtn) closeBtn.addEventListener('click',close);

  // --- klawiatura: Escape zamyka, Tab krąży wewnątrz panelu (aria-modal bez pułapki fokusu
  //     pozwalał wyjść tabulatorem na stronę pod spodem) ---
  var FOCUSABLE='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown',function(e){
    if(!root.classList.contains('is-open')) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key!=='Tab') return;
    var nodes=Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function(n){
      return n.offsetParent!==null || n===document.activeElement;
    });
    if(!nodes.length) return;
    var first=nodes[0], last=nodes[nodes.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    else if(!panel.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
  });

  // --- pobranie i render koszyka ---
  function getCart(){ return fetch(URL_CART,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  // --- SMART UPSELL: odświeżanie kart po zmianie koszyka ---
  // Liquid renderuje karty upsellu wg tego co jest w koszyku:
  //   → metapole upsell.recommended_ids (priorytet)
  //   → kolekcja fallback (gdy brak rekomendacji)
  // Po każdej zmianie koszyka JS pobiera świeży HTML sekcji przez Section Rendering API
  // i podmienia karty upsellu. Dzięki temu rekomendacje dostosowują się do zawartości koszyka.
  var SECTION_ID=root.getAttribute('data-section-id')||'ee-cart-drawer';
  var upsellContainer=document.getElementById('ee-cd-upsell');
  var upsellRefreshPending=false;
  var cartBusy=false;  // blokada równoległych zmian koszyka (zapobiega wyścigowi z nieświeżym kluczem linii)
  var upsellRefreshQueued=false;

  // Podmiana bloku upsellu na podstawie gotowego HTML sekcji.
  function applyUpsellHtml(html){
    if(!html) return;
    var tmp=document.createElement('div');
    tmp.innerHTML=html;
    var newUpsell=tmp.querySelector('#ee-cd-upsell');
    var oldUpsell=document.getElementById('ee-cd-upsell');
    if(newUpsell && oldUpsell){
      oldUpsell.innerHTML=newUpsell.innerHTML;
      oldUpsell.setAttribute('data-upsell-source', newUpsell.getAttribute('data-upsell-source')||'');
    }else if(newUpsell && !oldUpsell){
      var foot=document.getElementById('ee-cd-foot');
      if(foot) foot.parentElement.insertBefore(newUpsell.cloneNode(true), foot);
    }else if(!newUpsell && oldUpsell){
      oldUpsell.remove();
    }
    upsellTrack=document.getElementById('ee-cd-upsell-track');
    lastSortKey=null;
    initUpsellNav();
    readShipMap(tmp);
    renderShipAndUpsell(lastCart);
  }

  // Wyciąga HTML naszej sekcji z odpowiedzi Cart API (res.data.sections[...]).
  // Ten HTML jest GWARANTOWANIE spójny ze stanem koszyka po zmianie (ta sama operacja),
  // więc produkty w koszyku są poprawnie wykluczone z upsellu.
  function upsellHtmlFromCartResponse(data){
    if(data && data.sections && data.sections[SECTION_ID]){ return data.sections[SECTION_ID]; }
    return null;
  }

  // Fallback: osobne zapytanie do Section Rendering API (gdy nie mamy odpowiedzi Cart API,
  // np. przy otwarciu koszyka kliknięciem w ikonę). Cart API jest preferowane, bo jego
  // render jest spójny ze stanem koszyka; osobne zapytanie potrafi renderować sekcję
  // ze stanem koszyka opóźnionym o ułamek sekundy.
  function refreshUpsell(){
    if(upsellRefreshPending){ upsellRefreshQueued=true; return; }
    upsellRefreshPending=true;
    var basePath=window.location.pathname;
    var sep=(basePath.indexOf('?')!==-1?'&':'?');
    var url=basePath+sep+'sections='+SECTION_ID+'&_='+Date.now();
    fetch(url,{headers:{'Accept':'application/json'},cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(data){ applyUpsellHtml(data[SECTION_ID]); })
      .catch(function(){})
      .then(function(){
        upsellRefreshPending=false;
        if(upsellRefreshQueued){ upsellRefreshQueued=false; refreshUpsell(); }
      });
  }

  // upsell: sortowanie kart wg brakującej kwoty do progu (remaining w groszach)
  //
  // ZASADA: manual i AI to CELOWANE rekomendacje — ich sens to trafność, nie dobicie
  // do progu. Zostają więc ZAWSZE w kolejności ustalonej w Liquid (interleave faz).
  // Sortowaniu "ile brakuje do darmowej wysyłki" podlega TYLKO faza collection
  // (fallback z kolekcji upsell), bo to produkty ogólne, które równie dobrze mogą
  // pełnić rolę "dobierz do progu".
  //
  // Efekt: [manual w kolejności][AI w kolejności][kolekcja posortowana pod próg]
  var upsellTrack=document.getElementById('ee-cd-upsell-track');
  var lastSortKey=null;
  function sortUpsell(remaining){
    if(!upsellTrack) return;
    var cards=Array.prototype.slice.call(upsellTrack.querySelectorAll('.ee-cd__up'));
    if(!cards.length) return;
    // przelicz tylko gdy realnie zmienia się kwota do progu (albo brak progu)
    var key=(!remaining||remaining<=0)?'none':String(remaining);
    if(key===lastSortKey) return;
    lastSortKey=key;

    // rozdziel karty na priorytetowe (manual+AI) i kolekcję
    var priority=[]; // manual + ai — kolejność z Liquid nienaruszona
    var collection=[];
    cards.forEach(function(c){
      var phase=c.getAttribute('data-upsell-phase');
      if(phase==='collection'){ collection.push(c); }
      else { priority.push(c); }
    });

    // priorytetowe: przywróć oryginalną kolejność z Liquid (data-index rosnąco)
    priority.sort(function(a,b){ return (+a.getAttribute('data-index'))-(+b.getAttribute('data-index')); });

    // kolekcja: pod próg (jeśli jest), inaczej oryginalna kolejność
    if(!remaining || remaining<=0){
      collection.sort(function(a,b){ return (+a.getAttribute('data-index'))-(+b.getAttribute('data-index')); });
    }else{
      collection.sort(function(a,b){
        var pa=+a.getAttribute('data-price'), pb=+b.getAttribute('data-price');
        var aHits=pa>=remaining, bHits=pb>=remaining;
        if(aHits && bHits) return pa-pb;      // oba dobijają → tańszy z dobijających pierwszy
        if(aHits) return -1;                  // dobijający przed niedobijającym
        if(bHits) return 1;
        return pb-pa;                          // żaden nie dobija → droższy pierwszy (bliżej progu)
      });
    }

    // złóż z powrotem: najpierw manual+AI, potem kolekcja
    priority.concat(collection).forEach(function(c){ upsellTrack.appendChild(c); });
    upsellTrack.scrollLeft=0;
  }

  function render(cart){
    lastCart=cart;
    // licznik
    countEl.textContent=cart.item_count;
    renderShipAndUpsell(cart);
    renderItems(cart);
  }

  // pasek darmowej dostawy + sortowanie i badge upsellu
  // (wywoływane też po podmianie HTML sekcji, bo wtedy przychodzi świeża mapa kosztów dostawy i nowe karty)
  function renderShipAndUpsell(cart){
    if(!cart) return;
    var blocked=shipBlocked(cart);
    var shipBox=document.getElementById('ee-cd-ship');
    // Produkt z drogą dostawą w koszyku:
    //  - poniżej progu: chowamy pasek całkiem (nie obiecujemy licznikiem i nie straszymy komunikatem,
    //    darmowa wysyłka i tak jeszcze nie przysługuje),
    //  - od progu: pokazujemy, że darmowa wysyłka nie przysługuje (żeby nie było rozczarowania w kasie).
    var hideShip=blocked && cart.item_count>0 && thresholdCents>0 && cart.total_price<thresholdCents;
    if(shipBox){
      shipBox.classList.toggle('is-blocked', blocked && cart.item_count>0 && !hideShip);
      shipBox.classList.toggle('is-hidden', hideShip);
    }
    // pasek dostawy
    if(shipMsg && shipFill && thresholdCents>0){
      var total=cart.total_price;
      var pct=Math.min(100, Math.round(total/thresholdCents*100));
      shipFill.style.width=pct+'%';
      shipMsg.classList.remove('is-blocked');
      if(blocked && cart.item_count>0){
        // produkt z droższą dostawą: darmowa wysyłka nie przysługuje niezależnie od kwoty
        shipMsg.innerHTML=esc(MSG_BLOCKED)+(MSG_BLOCKED_NOTE?'<span class="ee-cd__ship-note">'+esc(MSG_BLOCKED_NOTE)+'</span>':'');
        shipMsg.classList.remove('is-reached'); shipFill.classList.remove('is-reached');
        shipMsg.classList.add('is-blocked');
      }else if(total>=thresholdCents){
        var reached=root.getAttribute('data-msg-reached')||'Free shipping!';
        var note=MSG_REACHED_NOTE?'<span class="ee-cd__ship-note">'+esc(MSG_REACHED_NOTE)+'</span>':'';
        shipMsg.innerHTML='✓ '+esc(reached)+note;
        shipMsg.classList.add('is-reached'); shipFill.classList.add('is-reached');
      }else{
        var left=money(thresholdCents-total);
        var tmpl=root.getAttribute('data-msg-progress')||'Free shipping in %amount%';
        shipMsg.innerHTML=tmpl.replace('%amount%','<b>'+left+'</b>');
        shipMsg.classList.remove('is-reached'); shipFill.classList.remove('is-reached');
      }
    }
    // upsell: posortuj wg brakującej kwoty do progu (przy blokadzie dobijanie do progu nic nie daje)
    var remaining=(thresholdCents>0 && !blocked) ? Math.max(0, thresholdCents - cart.total_price) : 0;
    sortUpsell(remaining);

    // upsell: badge darmowej wysyłki — zielona ikonka ciężarówki w rogu zdjęcia,
    // tooltip z pełnym tekstem na hover. Pusty label w ustawieniach = wyłączona funkcja.
    // UWAGA: badge pojawia się TYLKO na kartach fazy 'collection' — manual i AI są
    // celowanymi rekomendacjami oderwanymi od progu darmowej wysyłki (zgodnie z logiką
    // sortowania: tylko kolekcja pełni rolę "dobierz do progu").
    if(upsellTrack && LBL_FREESHIP){
      var cartIds={};
      cart.items.forEach(function(it){ cartIds[String(it.variant_id)]=true; });
      var SHIP_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 17H1V7h12v10m0 0h6V12l-3-3h-3M8 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"/></svg>';
      var upCards=upsellTrack.querySelectorAll('.ee-cd__up');
      upCards.forEach(function(card){
        var existing=card.querySelector('.ee-cd__up-ship');
        var addBtn=card.querySelector('.ee-cd__up-add');
        var inCart=addBtn && cartIds[addBtn.getAttribute('data-variant-id')];
        var isCollection=card.getAttribute('data-upsell-phase')==='collection';
        if(isCollection && !inCart && remaining>0 && (+card.getAttribute('data-price'))>=remaining){
          if(!existing){
            var badge=document.createElement('div');
            badge.className='ee-cd__up-ship';
            badge.setAttribute('data-tip',LBL_FREESHIP);
            badge.innerHTML=SHIP_SVG;
            // wstaw na początek karty (nakłada się na lewy górny róg zdjęcia)
            card.insertBefore(badge, card.firstChild);
          }
        }else{
          if(existing) existing.remove();
        }
      });
    }
  }

  function renderItems(cart){
    // pozycje
    if(cart.item_count===0){
      itemsEl.innerHTML='';
      emptyEl.hidden=false;
      footEl.hidden=true;
      return;
    }
    emptyEl.hidden=true;
    footEl.hidden=false;
    subtotalEl.innerHTML=money(cart.total_price);
    var html='';
    cart.items.forEach(function(it){
      var was='';
      if(it.original_line_price>it.final_line_price){
        was='<span class="ee-cd__was">'+money(it.original_line_price)+'</span>';
      }
      var variant=(it.variant_title && it.variant_title!=='Default Title')?('<div class="ee-cd__item-variant">'+esc(it.variant_title)+'</div>'):'';
      var img=it.image?('<img src="'+esc(it.image.replace(/(\.[^./]+)(\?|$)/,'_120x120$1$2'))+'" alt="" loading="lazy">'):'';
      var itemUrl=it.url?esc(it.url):'';
      var nameHtml=itemUrl
        ? '<a class="ee-cd__item-name ee-cd__item-name--link" href="'+itemUrl+'" data-ee-no-drawer>'+esc(it.product_title)+'</a>'
        : '<p class="ee-cd__item-name">'+esc(it.product_title)+'</p>';
      html+=''
        +'<li class="ee-cd__item" data-key="'+esc(it.key)+'">'
        +'  <div class="ee-cd__item-img">'+img+'</div>'
        +'  <div class="ee-cd__item-mid">'
        +     nameHtml
        +     variant
        +'    <div class="ee-cd__qty">'
        +'      <button type="button" data-act="dec" aria-label="'+esc(LBL_LESS)+'">−</button>'
        +'      <span>'+it.quantity+'</span>'
        +'      <button type="button" data-act="inc" aria-label="'+esc(LBL_MORE)+'">+</button>'
        +'    </div>'
        +'  </div>'
        +'  <div class="ee-cd__item-right">'
        +'    <div class="ee-cd__item-price">'+money(it.final_line_price)+was+'</div>'
        +'    <button type="button" class="ee-cd__remove" data-act="remove">'+esc(LBL_REMOVE)+'</button>'
        +'  </div>'
        +'</li>';
    });
    itemsEl.innerHTML=html;
  }

  function refresh(){ return getCart().then(function(cart){ render(cart); refreshUpsell(); return cart; }); }

  // --- zmiana ilości / usuwanie (Cart Change API) ---
  // zwraca {ok:bool, data:obiekt} — bez tego błędy 422 z Shopify wyglądały jak sukces
  function readJson(r){
    return r.json().catch(function(){ return {}; }).then(function(d){ return {ok:r.ok, data:d}; });
  }
  function errText(d){
    return (d && (d.description || d.message)) || MSG_ERROR;
  }

  function changeLine(key, quantity){
    // blokada równoległych operacji — bez niej szybkie klikanie wysyłało zmianę ze
    // starym (nieświeżym) kluczem linii, na co Shopify odpowiada 422
    // "inget giltigt id / no valid id". Dopóki jedna zmiana trwa, kolejne są ignorowane.
    if(cartBusy) return;
    cartBusy=true;
    // oznacz TYLKO edytowaną pozycję jako busy (puls) — reszta koszyka działa normalnie
    var li=itemsEl.querySelector('.ee-cd__item[data-key="'+key+'"]');
    if(li) li.classList.add('is-busy');
    clearError();
    return fetch(URL_CHANGE,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      // sections: prosimy Shopify, żeby w TEJ SAMEJ odpowiedzi zwrócił odświeżony HTML
      // sekcji — spójny z nowym stanem koszyka. Dzięki temu produkty w koszyku są
      // poprawnie wykluczone z upsellu (koniec z produktem, który jest i w koszyku, i w upsellu).
      body:JSON.stringify({id:key,quantity:quantity,sections:SECTION_ID,sections_url:window.location.pathname})
    }).then(readJson).then(function(res){
      if(!res.ok){
        // Nieświeży klucz linii (422) to nie błąd dla klienta — to rozjechany stan.
        // Zamiast czerwonego komunikatu po prostu cicho przeładuj realny koszyk.
        return refresh();
      }
      render(res.data);
      var html=upsellHtmlFromCartResponse(res.data);
      if(html){ applyUpsellHtml(html); }   // spójny render z Cart API
      else { refreshUpsell(); }             // fallback, gdyby sekcji nie było w odpowiedzi
      syncHeaderCount(res.data.item_count);
    }).catch(function(){
      // gdyby fetch się nie udał — zdejmij busy i przeładuj koszyk (bez straszenia błędem)
      if(li) li.classList.remove('is-busy');
      return refresh();
    }).then(function(){
      cartBusy=false;   // zwolnij blokadę niezależnie od wyniku
    });
  }

  itemsEl.addEventListener('click',function(e){
    var btn=e.target.closest('button'); if(!btn) return;
    var li=e.target.closest('.ee-cd__item'); if(!li) return;
    var key=li.getAttribute('data-key');
    var act=btn.getAttribute('data-act');
    var qtySpan=li.querySelector('.ee-cd__qty span');
    var cur=parseInt(qtySpan.textContent,10)||1;
    if(act==='inc') changeLine(key,cur+1);
    else if(act==='dec') changeLine(key,Math.max(0,cur-1));
    else if(act==='remove') changeLine(key,0);
  });

  // --- dodawanie (przechwytywanie /cart/add) ---
  var _addingBtn=null;
  function addVariant(id, qty, triggerBtn, properties){
    cartBusy=true;   // na czas dodawania zablokuj zmiany ilości/usuwanie (klucze linii się zmieniają)
    if(_addingBtn) _addingBtn.disabled=false;
    _addingBtn=triggerBtn||null;
    if(_addingBtn) _addingBtn.disabled=true;
    clearError();
    var item={id:id,quantity:qty||1};
    if(properties) item.properties=properties;
    return fetch(URL_ADD,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[item],sections:SECTION_ID,sections_url:window.location.pathname})
    }).then(readJson).then(function(res){
      // pobierz świeży koszyk (do listy pozycji, paska, licznika)
      return getCart().then(function(cart){
        render(cart);
        // upsell: preferuj spójny HTML z odpowiedzi /cart/add (zawiera już nowy produkt,
        // więc jest on wykluczony z rekomendacji); fallback na osobne zapytanie
        var html=upsellHtmlFromCartResponse(res.data);
        if(html){ applyUpsellHtml(html); } else { refreshUpsell(); }
        if(_addingBtn){ _addingBtn.disabled=false; _addingBtn=null; }
        open();
        if(!res.ok) showError(errText(res.data));
        if(cart) syncHeaderCount(cart.item_count);
        return cart;
      });
    }).catch(function(){
      if(_addingBtn){ _addingBtn.disabled=false; _addingBtn=null; }
      open();
      showError(MSG_ERROR);
    }).then(function(){
      cartBusy=false;   // zwolnij blokadę po zakończeniu dodawania (sukces lub błąd)
    });
  }

  // upsell "dodaj" — dwie warstwy śledzenia:
  //   1) line item property (_upsell_source) → źródło (manual/ai/collection) widoczne
  //      przy pozycji w zamówieniu. Właściwość jest przyklejona do POZYCJI, więc gdy
  //      klient usunie produkt, znika razem z nim — w zamówieniu nie zostaje "duch".
  //   2) dataLayer event (add_to_cart) → GA4 pokazuje dodania BEZ zamówienia
  root.addEventListener('click',function(e){
    var up=e.target.closest('.ee-cd__up-add'); if(!up) return;
    var id=up.getAttribute('data-variant-id'); if(!id) return;
    var card=up.closest('.ee-cd__up');
    var name=card?(card.querySelector('.ee-cd__up-name')||{}).textContent||'':'';
    var priceCents=card?+(card.getAttribute('data-price')||0):0;
    var cur=root.getAttribute('data-currency')||'PLN';
    // faza karty: manual / ai / collection (ustawiona w Liquid jako data-upsell-phase)
    var phase=card?(card.getAttribute('data-upsell-phase')||'collection'):'collection';

    // --- GA4 / GTM dataLayer: event PRZED fetchem, żeby złapać nawet porzucone koszyki ---
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({ecommerce:null}); // wyczyść poprzedni obiekt e-commerce
      window.dataLayer.push({
        event:'add_to_cart',
        ecommerce:{
          currency:cur,
          value:priceCents/100,
          items:[{
            item_id:String(id),
            item_name:name.trim(),
            item_list_name:'cart_upsell',
            item_variant:phase,   // źródło upsellu w GA4
            price:priceCents/100,
            quantity:1
          }]
        }
      });
    }catch(e){}

    // line item property — źródło upsellu (manual/ai/collection) na tej konkretnej pozycji
    addVariant(id, 1, up, {
      _upsell_source: phase
    });
  });

  // przechwyć wszystkie formularze dodawania do koszyka na stronie
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form || form.getAttribute('action')===null) return;
    if(form.hasAttribute('data-ee-no-drawer')) return;
    // Dynamiczne przyciski płatności (PayPal Express, Google Pay, Shop Pay, Apple Pay) —
    // mają własną logikę SDK dostawcy płatności. Przechwycenie ich submitu przez nasz
    // fetch zepsułoby cały przepływ (np. otwarcie natywnego arkusza płatności).
    if(e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    var action=form.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // zablokuj handler motywu — bez tego motyw otworzy swój drawer/page
    var fd=new FormData(form);
    // poproś o odświeżony HTML sekcji spójny z nowym stanem koszyka
    fd.append('sections', SECTION_ID);
    fd.append('sections_url', window.location.pathname);
    var submitBtn=e.submitter || form.querySelector('[type="submit"]');
    if(submitBtn) submitBtn.disabled=true;
    clearError();
    fetch(URL_ADD,{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(readJson)
      .then(function(res){
        return getCart().then(function(cart){
          render(cart);
          var html=upsellHtmlFromCartResponse(res.data);
          if(html){ applyUpsellHtml(html); } else { refreshUpsell(); }
          if(submitBtn) submitBtn.disabled=false;
          open();
          if(!res.ok) showError(errText(res.data));
          if(cart) syncHeaderCount(cart.item_count);
        });
      })
      .catch(function(){ if(submitBtn) submitBtn.disabled=false; form.submit(); });
  },true);

  // --- przechwyć klik w ikonę koszyka w nagłówku ---
  // selektor konfigurowalny + rozsądne domyślne dla popularnych motywów
  var defaultIconSelectors=[
    'a[href="/cart"]','a[href$="/cart"]',
    '.cart-link','.header__icon--cart','.site-header__cart',
    '#cart-icon-bubble','[data-cart-icon]','.js-drawer-open-cart'
  ];
  var selectors=defaultIconSelectors.slice();
  if(iconSelector){ selectors=iconSelector.split(',').map(function(s){return s.trim();}).concat(selectors); }
  document.addEventListener('click',function(e){
    // element (lub jego rodzic) z data-ee-no-drawer ma działać normalnie —
    // np. link "więcej metod płatności" na stronie produktu prowadzi do STRONY koszyka
    if(e.target.closest && e.target.closest('[data-ee-no-drawer]')) return;
    for(var i=0;i<selectors.length;i++){
      var el=e.target.closest(selectors[i]);
      if(el){
        e.preventDefault();
        e.stopImmediatePropagation(); // zablokuj handler motywu
        open(); refresh(); return;
      }
    }
  },true);

  // --- synchronizacja licznika w nagłówku (best-effort) ---
  function syncHeaderCount(count){
    var nodes=document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count],#cart-icon-bubble .cart-count-bubble span');
    nodes.forEach(function(n){ n.textContent=count; });
  }

  // --- popup warunków darmowej wysyłki ---
  var shipInfoBtn=document.getElementById('ee-cd-ship-info-btn');
  var shipPopup=document.getElementById('ee-cd-ship-popup');
  var shipPopupClose=document.getElementById('ee-cd-ship-popup-close');
  if(shipInfoBtn && shipPopup){
    shipInfoBtn.addEventListener('click',function(){
      var open=!shipPopup.hasAttribute('hidden');
      if(open){ shipPopup.setAttribute('hidden',''); }
      else{ shipPopup.removeAttribute('hidden'); }
    });
    if(shipPopupClose) shipPopupClose.addEventListener('click',function(){ shipPopup.setAttribute('hidden',''); });
  }

  // upsell: zwijanie sekcji + nawigacja — wyodrębnione do funkcji,
  // bo po refreshUpsell() karty są podmieniane i eventy trzeba podpiąć ponownie
  function initUpsellNav(){
    var upsellBox=document.getElementById('ee-cd-upsell');
    var toggle=document.getElementById('ee-cd-upsell-toggle');
    if(upsellBox && toggle){
      // usuwamy stare listenery przez klonowanie elementu
      var newToggle=toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);
      newToggle.addEventListener('click',function(){
        var collapsed=upsellBox.classList.toggle('is-collapsed');
        newToggle.setAttribute('aria-expanded',String(!collapsed));
      });
    }

    var track=document.getElementById('ee-cd-upsell-track');
    var prev=document.getElementById('ee-cd-up-prev');
    var next=document.getElementById('ee-cd-up-next');
    if(track && prev && next){
      var newPrev=prev.cloneNode(true); prev.parentNode.replaceChild(newPrev, prev);
      var newNext=next.cloneNode(true); next.parentNode.replaceChild(newNext, next);
      var stepBy=function(){ return Math.max(120, track.clientWidth*0.7); };
      newPrev.addEventListener('click',function(){ track.scrollBy({left:-stepBy(),behavior:'smooth'}); });
      newNext.addEventListener('click',function(){ track.scrollBy({left:stepBy(),behavior:'smooth'}); });
      var updateNav=function(){
        var max=track.scrollWidth-track.clientWidth-2;
        newPrev.disabled=track.scrollLeft<=2;
        newNext.disabled=track.scrollLeft>=max;
      };
      track.addEventListener('scroll',updateNav,{passive:true});
      setTimeout(updateNav,50);
    }
  }
  initUpsellNav();

  // start
  window.EE_CART_DRAWER.open=function(){ open(); refresh(); };
  window.EE_CART_DRAWER.refresh=refresh;
  document.dispatchEvent(new CustomEvent('ee:cart-drawer-ready'));
  refresh();

  // --- CHECKOUT ---
  // Formularz "Do kasy" jest samowystarczalny: action=routes.cart_url, method=post,
  // ukryte pole name="checkout" → Shopify sam przekierowuje prosto do kasy przy zwykłym
  // submitcie. Nie przechwytujemy go JS-em: źródło upsellu zapisujemy jako line item
  // property (_upsell_source) już przy dodaniu, więc nie ma nic do ustawiania przy checkoucie.
  // (Wcześniejsze ustawianie atrybutów koszyka _has_upsell było źródłem "duchów" w zamówieniach
  //  i zostało usunięte — property na pozycji znika automatycznie, gdy klient usunie produkt.)

  // --- WYŁĄCZENIE WBUDOWANEGO DRAWERA MOTYWU ---
  // MutationObserver: gdy motyw dynamicznie otwiera swój drawer (zmiana class/style/open),
  // natychmiast go chowamy. Działa na Dawn, Debut, Sense, Craft i większość motywów.
  (function(){
    var THEME_SEL=[
      'cart-drawer','cart-notification','.cart-drawer','#CartDrawer',
      '.mini-cart','[data-cart-drawer]','#cart-drawer','.drawer--cart',
      '.quick-cart','[id*="cart-drawer"]:not(#ee-cd)',
      '[class*="cart-drawer"]:not(.ee-cd-root)'
    ];
    function kill(){
      THEME_SEL.forEach(function(s){
        try{
          document.querySelectorAll(s).forEach(function(el){
            if(el===root||root.contains(el)||el.contains(root)) return;
            el.style.setProperty('display','none','important');
            el.setAttribute('aria-hidden','true');
            try{el.close&&el.close();}catch(x){}
            try{el.open=function(){};el.show=function(){};}catch(x){}
          });
        }catch(e){}
      });
    }
    kill();
    try{
      new MutationObserver(kill).observe(document.body,
        {childList:true,subtree:true,attributes:true,attributeFilter:['class','style','open']});
    }catch(e){}
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-promo-timer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function parts(date, tz){
    var o = {};
    new Intl.DateTimeFormat('en-US',{timeZone:tz,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false})
      .formatToParts(date).forEach(function(p){ o[p.type] = p.value; });
    return {y:+o.year, mo:+o.month, d:+o.day, h:(o.hour === '24' ? 0 : +o.hour), mi:+o.minute, s:+o.second};
  }
  function offset(date, tz){
    var p = parts(date, tz);
    return Date.UTC(p.y, p.mo-1, p.d, p.h, p.mi, p.s) - (date.getTime() - date.getTime() % 1000);
  }
  // "DD.MM.RRRR GG:MM" (lub "RRRR-MM-DD GG:MM") w strefie tz -> timestamp
  function parseWall(s, tz){
    s = String(s || '').trim();
    if(!s) return null;
    var m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T,]+(\d{1,2})[:.](\d{2}))?$/), y, mo, d, h, mi;
    if(m){ d = +m[1]; mo = +m[2]; y = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0; }
    else{
      m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?$/);
      if(!m) return null;
      y = +m[1]; mo = +m[2]; d = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0;
    }
    var guess = Date.UTC(y, mo-1, d, h, mi, 0);
    var ts = guess - offset(new Date(guess), tz);
    return guess - offset(new Date(ts), tz);
  }
  var pad = function(n){ return String(n).padStart(2, '0'); };

  function init(root){
    if(!root || root.getAttribute('data-ept-ready')) return;
    root.setAttribute('data-ept-ready', '1');
    var tz = root.getAttribute('data-tz') || 'Europe/Warsaw';
    try{ new Intl.DateTimeFormat('en-US',{timeZone:tz}); }catch(e){ tz = 'Europe/Warsaw'; }
    var start = parseWall(root.getAttribute('data-start'), tz);
    var end = parseWall(root.getAttribute('data-end'), tz);
    var p2 = parseWall(root.getAttribute('data-p2-from'), tz);
    var before = root.getAttribute('data-before') || 'countdown';
    var lblEnds = root.getAttribute('data-lbl-ends') || '';
    var lblStarts = root.getAttribute('data-lbl-starts') || lblEnds;
    var lblEl = root.querySelector('.ept__lbl');
    var u = {d:root.querySelector('[data-u="d"]'), h:root.querySelector('[data-u="h"]'), m:root.querySelector('[data-u="m"]'), s:root.querySelector('[data-u="s"]')};
    var p1Els = root.querySelectorAll('[data-p1]'), p2Els = root.querySelectorAll('[data-p2]');
    if(!end){ if(window.console) console.warn('[EE timer] Zly format daty konca (DD.MM.RRRR GG:MM).'); return; }

    var timer = null, lastPhase = null;
    function setPhase(two){
      if(two === lastPhase) return;
      lastPhase = two;
      p1Els.forEach(function(e){ if(two) e.setAttribute('hidden',''); else e.removeAttribute('hidden'); });
      p2Els.forEach(function(e){ if(two) e.removeAttribute('hidden'); else e.setAttribute('hidden',''); });
    }
    function tick(){
      if(!document.body.contains(root)){ clearInterval(timer); return; }
      var t = Date.now(), target, label;
      if(start && t < start){
        if(before !== 'countdown'){ root.setAttribute('hidden',''); return; }
        target = start; label = lblStarts;
      }else if(t < end){
        target = end; label = lblEnds;
      }else{
        root.setAttribute('hidden','');
        clearInterval(timer);
        return;
      }
      setPhase(!!(p2 && t >= p2 && t < end));
      if(lblEl && lblEl.textContent !== label) lblEl.textContent = label;
      var diff = target - t;
      u.d.textContent = pad(Math.floor(diff/86400000));
      u.h.textContent = pad(Math.floor(diff%86400000/3600000));
      u.m.textContent = pad(Math.floor(diff%3600000/60000));
      u.s.textContent = pad(Math.floor(diff%60000/1000));
      root.removeAttribute('hidden');
    }
    timer = setInterval(tick, 1000);
    tick();
  }
  function initAll(){ document.querySelectorAll('.ept').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // edytor motywu: sekcja przeładowana po zmianie ustawień
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('.ept')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='ee_recently_viewed';
  var MAXSTORE=20;

  function read(){
    try{ var v=JSON.parse(window.localStorage.getItem(KEY)||'[]'); return Array.isArray(v)?v:[]; }
    catch(e){ return []; }
  }
  function write(list){
    try{ window.localStorage.setItem(KEY, JSON.stringify(list.slice(0,MAXSTORE))); }catch(e){}
  }

  var sections=document.querySelectorAll('.ee-rv');
  sections.forEach(function(root){
    if(root.dataset.eeRvInit) return;
    root.dataset.eeRvInit='1';

    // Zabezpieczenie: na stronie bywa pusty blok (typowo <div class="rte">), do którego
    // Shopify/motyw wstawia komunikat "This section doesn't currently include any content".
    // Ten blok jest POZA naszą sekcją (to inna, pusta sekcja motywu), więc szukamy globalnie.
    // Ukrywamy TYLKO element, którego cała treść to ten komunikat (zero ryzyka dla realnej treści).
    (function(){
      var MSG1="doesn't currently include any content";
      var MSG1b="doesn’t currently include any content"; // wariant z typograficznym apostrofem
      var MSG2="add content to this section";
      var candidates=document.querySelectorAll('.rte, .shopify-section-placeholder, [data-section-placeholder]');
      candidates.forEach(function(el){
        var t=(el.textContent||'').trim().toLowerCase();
        if(t && (t.indexOf(MSG1)!==-1 || t.indexOf(MSG1b)!==-1 || t.indexOf(MSG2)!==-1)){
          // ukryj sam element; jeśli to jedyna treść jego sekcji, ukryj też wrapper sekcji
          el.style.display='none';
          var sec=el.closest('.shopify-section');
          if(sec && (sec.textContent||'').trim().toLowerCase().indexOf(MSG1)!==-1){
            // wrapper zawiera tylko ten komunikat → schowaj całą pustą sekcję
            if((sec.textContent||'').trim().length < 120) sec.style.display='none';
          }
        }
      });
    })();

    var currentHandle=root.getAttribute('data-current-handle')||'';
    var max=parseInt(root.getAttribute('data-max'),10)||5;
    var addLabel=root.getAttribute('data-add-label')||'Add to cart';
    var heading=root.getAttribute('data-heading')||'Recently viewed';
    var prevLabel=root.getAttribute('data-prev-label')||'Previous';
    var nextLabel=root.getAttribute('data-next-label')||'Next';
    var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';
    var track=null; // powstanie dopiero w renderCards

    // 1) zapisz bieżący produkt na początek listy (bez duplikatu)
    if(currentHandle){
      var list=read().filter(function(h){ return h!==currentHandle; });
      list.unshift(currentHandle);
      write(list);
    }

    // 2) zbuduj listę do pokazania: wszystko z localStorage oprócz bieżącego
    var toShow=read().filter(function(h){ return h!==currentHandle; }).slice(0,max);
    if(!toShow.length){ return; } // pusto → sekcja zostaje hidden

    // 3) pobierz dane produktów i wyrenderuj karty (kolejność zachowana)
    var results=new Array(toShow.length);
    var pending=toShow.length;
    toShow.forEach(function(handle,idx){
      fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(p){ results[idx]=p; })
        .catch(function(){ results[idx]=null; })
        .then(function(){
          pending-=1;
          if(pending===0) renderCards(results);
        });
    });

    function money(cents){
      // preferuj globalny formatter ze strony produktu, jak jest
      if(typeof window.eeFormatMoney==='function'){ return window.eeFormatMoney(cents); }
      return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
    }
    function esc(s){
      return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function renderCards(products){
      var cards='';
      products.forEach(function(p){
        if(!p || !p.available) return; // pomiń niedostępne / niepobrane
        var variantId=(p.variants&&p.variants[0])?p.variants[0].id:'';
        if(!variantId) return;
        var img=p.featured_image?('<img src="'+esc(p.featured_image)+'" alt="" loading="lazy">'):'';
        cards+=''
          +'<div class="ee-rec__card" data-rec-phase="recent" data-price="'+(p.price||0)+'">'
          +'  <a class="ee-rec__img" href="'+esc(p.url)+'">'+img
          +'    <span class="ee-rec__view" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg></span>'
          +'  </a>'
          +'  <a class="ee-rec__name" href="'+esc(p.url)+'">'+esc(p.title)+'</a>'
          +'  <div class="ee-rec__price">'+money(p.price)+'</div>'
          +'  <button type="button" class="ee-rec__add" data-variant-id="'+esc(variantId)+'">'+esc(addLabel)+'</button>'
          +'</div>';
      });
      if(!cards){ return; } // wszystkie niedostępne → sekcja zostaje ukryta, nic nie wstawiamy

      // Zbuduj CAŁĄ strukturę dopiero teraz (nagłówek, strzałki, track) — wcześniej
      // sekcja była pusta, więc przy braku historii nic się nie pokazywało.
      var prevSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m15 18-6-6 6-6"/></svg>';
      var nextSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m9 6 6 6-6 6"/></svg>';
      root.innerHTML=''
        +'<div class="ee-rec__head">'
        +'  <h2 class="ee-rec__title">'+esc(heading)+'</h2>'
        +'  <div class="ee-rec__nav">'
        +'    <button type="button" class="ee-rec__arrow" data-dir="prev" aria-label="'+esc(prevLabel)+'">'+prevSvg+'</button>'
        +'    <button type="button" class="ee-rec__arrow" data-dir="next" aria-label="'+esc(nextLabel)+'">'+nextSvg+'</button>'
        +'  </div>'
        +'</div>'
        +'<div class="ee-rec__track">'+cards+'</div>';
      track=root.querySelector('.ee-rec__track');
      var wrap=root.closest('.ee-rv-wrap');
      if(wrap){ wrap.style.display=''; } else { root.style.display=''; }
      initNav();
      initAdd();
    }

    function initNav(){
      if(!track) return;
      var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
      var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
      function step(){ return Math.max(200, track.clientWidth*0.8); }
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
      function updateArrows(){
        if(!prev||!next) return;
        var m=track.scrollWidth-track.clientWidth-2;
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=m;
      }
      track.addEventListener('scroll',updateArrows,{passive:true});
      setTimeout(updateArrows,50);
      window.addEventListener('resize',updateArrows);
    }

    function initAdd(){
      root.addEventListener('click',function(e){
        var btn=e.target.closest('.ee-rec__add'); if(!btn) return;
        var id=btn.getAttribute('data-variant-id'); if(!id) return;
        btn.disabled=true;
        fetch(URL_ADD,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        }).then(function(r){ return r.json().catch(function(){return {};}); })
          .then(function(){
            btn.disabled=false;
            if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
              window.EE_CART_DRAWER.open();
            }else{
              document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
                var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
              });
            }
          }).catch(function(){ btn.disabled=false; });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-recommended"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sections=document.querySelectorAll('.ee-rec');
  sections.forEach(function(root){
    if(root.dataset.eeRecInit) return;
    var track=root.querySelector('.ee-rec__track');
    if(!track) return; // inna sekcja z klasą .ee-rec (np. podobne / ostatnio oglądane) jeszcze bez treści
    root.dataset.eeRecInit='1';
    var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';

    // --- nawigacja slidera ---
    var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
    var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
    function step(){ return Math.max(200, track.clientWidth*0.8); }
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    function updateArrows(){
      if(!prev||!next) return;
      var max=track.scrollWidth-track.clientWidth-2;
      prev.disabled=track.scrollLeft<=2;
      next.disabled=track.scrollLeft>=max;
    }
    track.addEventListener('scroll',updateArrows,{passive:true});
    setTimeout(updateArrows,50);
    window.addEventListener('resize',updateArrows);

    // --- dodawanie do koszyka: przez /cart/add.js, potem otwórz nasz drawer jeśli jest ---
    root.addEventListener('click',function(e){
      var btn=e.target.closest('.ee-rec__add'); if(!btn) return;
      var id=btn.getAttribute('data-variant-id'); if(!id) return;
      var label=btn.textContent;
      btn.disabled=true;
      fetch(URL_ADD,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:id,quantity:1}]})
      }).then(function(r){ return r.json().catch(function(){return {};}); })
        .then(function(){
          btn.disabled=false;
          // jeśli nasz drawer jest na stronie — otwórz go i odśwież
          if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
            window.EE_CART_DRAWER.open();
          }else{
            // brak drawera → zaktualizuj licznik w nagłówku (best-effort) i zostań na stronie
            document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
              var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
            });
          }
        }).catch(function(){ btn.disabled=false; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-similar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wraps=document.querySelectorAll('.ee-similar-wrap');
  wraps.forEach(function(wrap){
    if(wrap.dataset.eeSimInit) return;
    wrap.dataset.eeSimInit='1';

    var sectionId=wrap.getAttribute('data-section-id');
    var productId=wrap.getAttribute('data-product-id');
    var limit=wrap.getAttribute('data-limit')||'5';
    var intent=wrap.getAttribute('data-intent')||'related';
    if(!productId){ return; }

    // Product Recommendations API + Section Rendering API — dociagamy HTML sekcji
    // z wypelnionym recommendations.products (dziala tylko przez ten endpoint).
    var base=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var url=base+'recommendations/products?section_id='+encodeURIComponent(sectionId)
           +'&product_id='+encodeURIComponent(productId)
           +'&intent='+encodeURIComponent(intent)
           +'&limit='+encodeURIComponent(limit);

    fetch(url,{headers:{'Accept':'text/html'}})
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if(!html){ return; }
        // odpowiedz to pelny HTML sekcji; wyciagamy nasz wewnetrzny <section>
        var tmp=document.createElement('div');
        tmp.innerHTML=html;
        var inner=tmp.querySelector('.ee-similar');
        if(!inner){ return; } // brak rekomendacji → zostaw ukryte
        wrap.innerHTML='';
        wrap.appendChild(inner);
        wrap.style.display='';
        initNav(inner);
        initAdd(inner);
      })
      .catch(function(){}); // cichy fail — sekcja niekrytyczna

    function initNav(root){
      var track=root.querySelector('.ee-rec__track');
      if(!track) return;
      var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
      var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
      function step(){ return Math.max(200, track.clientWidth*0.8); }
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
      function upd(){
        if(!prev||!next) return;
        var m=track.scrollWidth-track.clientWidth-2;
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=m;
      }
      track.addEventListener('scroll',upd,{passive:true});
      setTimeout(upd,50);
      window.addEventListener('resize',upd);
    }

    function initAdd(root){
      var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';
      root.addEventListener('click',function(e){
        var btn=e.target.closest('button.ee-rec__add'); if(!btn) return;
        var id=btn.getAttribute('data-variant-id'); if(!id) return;
        btn.disabled=true;
        fetch(URL_ADD,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        }).then(function(r){ return r.json().catch(function(){return {};}); })
          .then(function(){
            btn.disabled=false;
            if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
              window.EE_CART_DRAWER.open();
            }else{
              document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
                var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
              });
            }
          }).catch(function(){ btn.disabled=false; });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-ee"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__eecInit) return;
  window.__eecInit = true;

  function root(){ return document.querySelector('.eec[data-section]'); }

  // ---- panel filtrów na telefonie ----
  function openFilters(r){ r.classList.add('is-filters-open'); document.documentElement.style.overflow='hidden'; }
  function closeFilters(r){ r.classList.remove('is-filters-open'); document.documentElement.style.overflow=''; }

  // ---- ładowanie wyników bez przeładowania strony (Section Rendering API) ----
  var busy = null;
  function load(url, push){
    var r = root(); if(!r) { window.location.href = url; return; }
    var sid = r.getAttribute('data-section');
    var keepOpen = r.classList.contains('is-filters-open');
    var openIdx = Array.prototype.map.call(r.querySelectorAll('.eec__f'), function(d){ return d.open; });
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    var fetchUrl = new URL(u.toString()); fetchUrl.searchParams.set('section_id', sid);
    if(busy) busy.abort();
    busy = ('AbortController' in window) ? new AbortController() : null;
    r.classList.add('is-loading');
    fetch(fetchUrl.toString(), busy ? {signal: busy.signal} : {})
      .then(function(res){ if(!res.ok) throw new Error(res.status); return res.text(); })
      .then(function(html){
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('.eec[data-section]');
        if(!fresh) throw new Error('no section');
        r.innerHTML = fresh.innerHTML;
        r.classList.remove('is-loading');
        // zachowaj otwarte/zamknięte grupy filtrów i otwarty panel na telefonie
        r.querySelectorAll('.eec__f').forEach(function(d, i){ if(openIdx[i] != null) d.open = openIdx[i] || d.open; });
        if(keepOpen) r.classList.add('is-filters-open'); else closeFilters(r);
        if(push !== false) history.pushState({eec:1}, '', u.pathname + u.search);
        if(!keepOpen){
          var top = r.getBoundingClientRect().top + window.scrollY - 20;
          if(window.scrollY > top) window.scrollTo({top: top, behavior: 'smooth'});
        }
      })
      .catch(function(e){ if(e && e.name === 'AbortError') return; window.location.href = u.toString(); });
  }

  function formUrl(form){
    var r = root();
    var base = (r && r.getAttribute('data-url')) || window.location.pathname;
    var params = new URLSearchParams();
    new FormData(form).forEach(function(val, key){ if(String(val).trim() !== '') params.append(key, val); });
    var sort = r && r.querySelector('[data-eec-sort]');
    if(sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    var q = params.toString();
    return base + (q ? '?' + q : '');
  }

  // filtry: checkbox od razu, cena po chwili
  var priceTimer = null;
  document.addEventListener('change', function(e){
    var form = e.target.closest && e.target.closest('[data-eec-form]');
    if(form){
      if(e.target.type === 'number'){ clearTimeout(priceTimer); priceTimer = setTimeout(function(){ load(formUrl(form)); }, 500); }
      else load(formUrl(form));
      return;
    }
    if(e.target.matches && e.target.matches('[data-eec-sort]')){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', e.target.value);
      u.searchParams.delete('page');
      load(u.pathname + u.search);
    }
  });
  document.addEventListener('submit', function(e){
    if(e.target.matches && e.target.matches('[data-eec-form]')){ e.preventDefault(); load(formUrl(e.target)); }
  });
  document.addEventListener('click', function(e){
    var t = e.target;
    var a = t.closest && t.closest('[data-eec-link]');
    if(a && !e.metaKey && !e.ctrlKey && !e.shiftKey){ e.preventDefault(); load(a.getAttribute('href')); return; }
    var r = root(); if(!r) return;
    if(t.closest && t.closest('[data-eec-open]')){ openFilters(r); return; }
    if(t.closest && t.closest('[data-eec-close]')){ closeFilters(r); return; }
  });
  document.addEventListener('keydown', function(e){
    var r = root();
    if(e.key === 'Escape' && r && r.classList.contains('is-filters-open')) closeFilters(r);
  });
  window.addEventListener('popstate', function(){ if(root()) load(window.location.pathname + window.location.search, false); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ee"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- formatowanie ceny wg shop.money_format (bez twardej waluty) ----
  function eeFormatMoney(cents, format){
    var f = format || window.EE_MONEY_FORMAT || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(number, precision, thousands, decimal){
      thousands = (thousands == null) ? ',' : thousands;
      decimal   = (decimal == null) ? '.' : decimal;
      precision = (precision == null) ? 2 : precision;
      if(isNaN(number) || number == null) return '0';
      var n = (number/100).toFixed(precision).split('.');
      var main = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return main + (n[1] ? decimal + n[1] : '');
    }
    var m = f.match(re);
    if(!m) return f;
    var v = '';
    switch(m[1]){
      case 'amount':                                 v = withDelims(cents, 2); break;
      case 'amount_no_decimals':                     v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator':            v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':v = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':       v = withDelims(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator':            v = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':v = withDelims(cents, 0, ' ', ','); break;
      default:                                       v = withDelims(cents, 2);
    }
    return f.replace(re, v);
  }
  window.eeFormatMoney = eeFormatMoney;

  // stan przeceny bieżącego wariantu — countdown pyta o to przed pokazaniem się.
  // (uwaga: w bloku javascript sekcji Liquid NIE jest przetwarzany — stan czytamy z DOM)
  var badgeEl = document.getElementById('ee-save-badge');
  var eeSaleState = { onSale: !!(badgeEl && !badgeEl.hasAttribute('hidden')) };

  // ===== TIMER PROMOCJI =====
  // Tryby (ustawienie "Tryb timera"):
  //   weekly: cykl tygodniowy (dzień końca + godzina końca, nowy start po przerwie)
  //   fixed:  stały termin od-do (np. Black Friday), z opcją odliczania do startu
  //           i powrotu do cyklu tygodniowego po końcu
  // Czas liczony w wybranej strefie (domyślnie Europe/Warsaw), odporny na zmianę czasu.
  (function(){
    var els = document.querySelectorAll('.ee-cycle');
    if(!els.length) return;
    var cfg = els[0];
    function attr(n, d){ var v = cfg.getAttribute(n); return (v == null || v === '') ? d : v; }

    var TZ = attr('data-cycle-tz', 'Europe/Warsaw');
    var MODE = attr('data-mode', 'weekly');
    var REQUIRE_SALE = attr('data-require-sale', '1') !== '0';
    var HIDE_ZERO_DAYS = attr('data-hide-zero-days', '0') === '1';
    var BEFORE = attr('data-before', 'hide');   // hide | countdown
    var AFTER = attr('data-after', 'hide');     // hide | weekly
    var LBL_ENDS = attr('data-lbl-ends', '');
    var LBL_STARTS = attr('data-lbl-starts', '');
    if(!LBL_STARTS || LBL_STARTS.indexOf('translation missing') !== -1) LBL_STARTS = LBL_ENDS;

    function hm(s, dh, dm){
      var p = String(s || '').split(':');
      var h = parseInt(p[0], 10), m = parseInt(p[1], 10);
      return [isNaN(h) ? dh : h, isNaN(m) ? dm : m];
    }
    var endDay = parseInt(attr('data-cycle-day', '0'), 10); if(isNaN(endDay)) endDay = 0; // 0=niedziela
    var endT = hm(attr('data-cycle-end', '15:00'), 15, 0);
    var startT = hm(attr('data-cycle-start', '15:05'), 15, 5);

    var pad = function(n){ return String(n).padStart(2, '0'); };
    var setNum = function(name, val){ document.querySelectorAll('[data-cd="'+name+'"]').forEach(function(n){ n.textContent = pad(val); }); };

    // ---- widoczność: timer aktywny + (jeśli wymagane) bieżący wariant przeceniony ----
    var active = false, curLabel = null;
    var apply = function(){
      var v = active && (!REQUIRE_SALE || eeSaleState.onSale);
      els.forEach(function(e){ if(v){ e.removeAttribute('hidden'); } else { e.setAttribute('hidden', ''); } });
    };
    var show = function(v){ active = v; apply(); };
    // wywoływane przez obsługę wariantów, gdy zmienia się stan przeceny
    window.eeRefreshCycle = apply;

    function setLabel(kind){
      if(kind === curLabel) return;
      curLabel = kind;
      var txt = kind === 'starts' ? LBL_STARTS : LBL_ENDS;
      els.forEach(function(e){ var l = e.querySelector('.ee-cycle-lbl'); if(l) l.textContent = txt; });
    }

    // ---- czas w strefie TZ ----
    var fmt = new Intl.DateTimeFormat('en-US', {timeZone:TZ, weekday:'short', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false});
    var dowMap = {Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6};
    function partsInTZ(date){
      var o = {}; fmt.formatToParts(date).forEach(function(p){ o[p.type] = p.value; });
      var h = (o.hour === '24') ? 0 : parseInt(o.hour, 10);
      return {y:+o.year, mo:+o.month, d:+o.day, h:h, mi:+o.minute, s:+o.second, dow:dowMap[o.weekday]};
    }
    function tzOffsetMs(date){
      var p = partsInTZ(date);
      var asUTC = Date.UTC(p.y, p.mo-1, p.d, p.h, p.mi, p.s);
      return asUTC - (date.getTime() - date.getTime() % 1000);
    }
    // realny timestamp (ms) dla "ściany zegara" w TZ
    function tzWallToTs(y, mo, d, h, mi){
      var guess = Date.UTC(y, mo-1, d, h, mi, 0);
      var off = tzOffsetMs(new Date(guess));
      var ts = guess - off;
      off = tzOffsetMs(new Date(ts));
      return guess - off;
    }
    // przesuwamy datę kalendarzową, nie milisekundy (zmiana czasu nie przesuwa godziny)
    function wallAtDayOffset(p, deltaDays, h, mi){
      var base = new Date(Date.UTC(p.y, p.mo-1, p.d) + deltaDays*86400000);
      return tzWallToTs(base.getUTCFullYear(), base.getUTCMonth()+1, base.getUTCDate(), h, mi);
    }

    // ---- data z ustawień: "DD.MM.RRRR GG:MM" (albo "RRRR-MM-DD GG:MM"); bez godziny = 00:00 ----
    function parseWall(s){
      s = String(s || '').trim();
      if(!s) return null;
      var m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T,]+(\d{1,2})[:.](\d{2}))?$/);
      var y, mo, d, h, mi;
      if(m){ d = +m[1]; mo = +m[2]; y = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0; }
      else{
        m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?$/);
        if(!m) return null;
        y = +m[1]; mo = +m[2]; d = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0;
      }
      if(mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59) return null;
      return tzWallToTs(y, mo, d, h, mi);
    }
    var FIX_START = parseWall(attr('data-fixed-start', ''));
    var FIX_END = parseWall(attr('data-fixed-end', ''));
    if(MODE === 'fixed' && !FIX_END && window.console) console.warn('[EE timer] Stały termin: brak lub zły format daty końca (DD.MM.RRRR GG:MM).');

    // ---- cykl tygodniowy: bieżące okno {start, end} ----
    function weeklyWindow(now){
      var p = partsInTZ(now);
      var delta = (endDay - p.dow + 7) % 7;
      var endTs = wallAtDayOffset(p, delta, endT[0], endT[1]);
      if(delta === 0 && now.getTime() >= endTs){ delta = 7; endTs = wallAtDayOffset(p, delta, endT[0], endT[1]); }
      var startTs = wallAtDayOffset(p, delta-7, startT[0], startT[1]);
      return {start:startTs, end:endTs};
    }
    function weeklyTarget(now){
      var w = weeklyWindow(now), t = now.getTime();
      if(t < w.start || t >= w.end) return null; // przerwa między oknami
      return {ts:w.end, kind:'ends'};
    }

    // ---- do czego teraz odliczamy (null = timer ukryty) ----
    function currentTarget(now){
      var t = now.getTime();
      if(MODE === 'fixed'){
        if(!FIX_END) return null;
        if(FIX_START && t < FIX_START) return BEFORE === 'countdown' ? {ts:FIX_START, kind:'starts'} : null;
        if(t < FIX_END) return {ts:FIX_END, kind:'ends'};
        return AFTER === 'weekly' ? weeklyTarget(now) : null;
      }
      return weeklyTarget(now);
    }

    var timer;
    function tick(){
      var now = new Date();
      var tg = currentTarget(now);
      if(!tg){
        show(false);
        // stały termin minął i nie wracamy do cyklu → nie ma już na co czekać
        if(MODE === 'fixed' && FIX_END && now.getTime() >= FIX_END && AFTER !== 'weekly' && timer) clearInterval(timer);
        return;
      }
      var diff = tg.ts - now.getTime();
      if(diff <= 0){ show(false); return; }
      setLabel(tg.kind);
      var days = Math.floor(diff/86400000);
      setNum('days', days);
      setNum('hours', Math.floor(diff%86400000/3600000));
      setNum('mins', Math.floor(diff%3600000/60000));
      setNum('secs', Math.floor(diff%60000/1000));
      document.querySelectorAll('[data-cd-wrap="days"]').forEach(function(w){
        if(HIDE_ZERO_DAYS && days === 0) w.setAttribute('hidden', ''); else w.removeAttribute('hidden');
      });
      show(true);
    }
    tick(); timer = setInterval(tick, 1000);
  })();
  // tytuł: chevron tylko gdy realnie przycięty
  var title=document.getElementById('ee-title'),tbtn=document.getElementById('ee-title-toggle');
  if(title&&tbtn){
    requestAnimationFrame(function(){if(title.scrollHeight>title.clientHeight+2)tbtn.classList.add('is-visible');});
    tbtn.addEventListener('click',function(){var o=tbtn.getAttribute('aria-expanded')==='true';tbtn.setAttribute('aria-expanded',String(!o));title.classList.toggle('is-expanded',!o);});
  }
  // ilość
  var q=document.getElementById('ee-qty');
  if(q){
    document.getElementById('ee-qminus').addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value,10)||1)-1);});
    document.getElementById('ee-qplus').addEventListener('click',function(){q.value=(parseInt(q.value,10)||1)+1;});
  }
  // galeria: jednolity swipe (PC + telefon), strzałki, kropki, miniatury — pełna synchronizacja
  (function(){
    var stage=document.getElementById('ee-stage');
    var track=document.getElementById('ee-track');
    if(!stage||!track)return;
    var slides=track.querySelectorAll('.stage__slide');
    var imgs=track.querySelectorAll('.stage__img');
    var thumbs=document.querySelectorAll('.thumb');
    var dots=document.querySelectorAll('.stage__dot');
    var prev=document.getElementById('ee-prev');
    var next=document.getElementById('ee-next');
    var current=0;

    function updateArrows(){
      if(prev)prev.disabled=(current<=0);
      if(next)next.disabled=(current>=slides.length-1);
    }
    function activate(i){
      current=i;
      imgs.forEach(function(im,k){im.classList.toggle('is-active',k===i);});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i);});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});
      var at=thumbs[i];
      if(at&&at.scrollIntoView)at.scrollIntoView({inline:'nearest',block:'nearest'});
      updateArrows();
    }
    function goTo(i){
      if(i<0)i=0;if(i>slides.length-1)i=slides.length-1;
      var s=slides[i];
      if(s)track.scrollTo({left:s.offsetLeft,behavior:'smooth'});
      activate(i);
    }

    // klik miniatury
    thumbs.forEach(function(th){
      th.addEventListener('click',function(){goTo(parseInt(th.dataset.index,10)||0);});
    });
    // strzałki
    if(prev)prev.addEventListener('click',function(){goTo(current-1);});
    if(next)next.addEventListener('click',function(){goTo(current+1);});

    // swipe -> aktualizacja stanu
    var raf;
    track.addEventListener('scroll',function(){
      if(raf)cancelAnimationFrame(raf);
      raf=requestAnimationFrame(function(){
        var i=Math.round(track.scrollLeft/track.clientWidth);
        if(i<0)i=0;if(i>slides.length-1)i=slides.length-1;
        if(i!==current)activate(i);
      });
    },{passive:true});

    updateArrows();
    // udostępniamy na zewnątrz — zmiana wariantu przełącza zdjęcie
    window.eeGalleryGoTo=goTo;

    // zoom na hover (desktop) — klik toggle, transform-origin podąża za kursorem
    if(window.matchMedia('(hover:hover) and (min-width:881px)').matches){
      slides.forEach(function(slide){
        var img=slide.querySelector('.stage__img');
        if(!img) return;
        slide.addEventListener('click',function(e){
          slide.classList.toggle('is-zoomed');
          if(slide.classList.contains('is-zoomed')){
            var rect=slide.getBoundingClientRect();
            var x=((e.clientX-rect.left)/rect.width*100).toFixed(1);
            var y=((e.clientY-rect.top)/rect.height*100).toFixed(1);
            img.style.transformOrigin=x+'% '+y+'%';
          }
        });
        slide.addEventListener('mousemove',function(e){
          if(!slide.classList.contains('is-zoomed')) return;
          var rect=slide.getBoundingClientRect();
          var x=((e.clientX-rect.left)/rect.width*100).toFixed(1);
          var y=((e.clientY-rect.top)/rect.height*100).toFixed(1);
          img.style.transformOrigin=x+'% '+y+'%';
        });
        slide.addEventListener('mouseleave',function(){
          slide.classList.remove('is-zoomed');
        });
      });
    }
  })();
  // accordion — po zakończeniu animacji otwarty panel dostaje max-height:none,
  // dzięki czemu doładowany obrazek / obrót telefonu / dłuższy tekst GPSR go nie przycina
  document.querySelectorAll('.acc__head').forEach(function(h){
    var p=h.nextElementSibling;
    if(!p) return;
    h.addEventListener('click',function(){
      var isOpen=h.getAttribute('aria-expanded')==='true';
      h.setAttribute('aria-expanded',String(!isOpen));
      if(isOpen){
        // zwijanie: z konkretnej wysokości do zera (inaczej "none" nie animuje)
        p.style.maxHeight=p.scrollHeight+'px';
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){ p.style.maxHeight='0px'; });
        });
      }else{
        p.style.maxHeight=p.scrollHeight+'px';
      }
    });
    p.addEventListener('transitionend',function(e){
      if(e.target!==p || e.propertyName!=='max-height') return;
      if(h.getAttribute('aria-expanded')==='true') p.style.maxHeight='none';
    });
  });
  // sticky add-to-cart
  var main=document.getElementById('ee-add'),bar=document.getElementById('ee-sticky');
  if(main&&bar&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){bar.classList.toggle('is-visible',!e.isIntersecting);bar.setAttribute('aria-hidden',String(e.isIntersecting));});},{threshold:0}).observe(main);
    var sa=document.getElementById('ee-sticky-add');if(sa)sa.addEventListener('click',function(){main.click();});
  }
  // ===== WARIANTY =====
  // dopasowanie po INDEKSIE opcji (nie po sklejaniu wartości separatorem),
  // pełna aktualizacja: cena, stara cena, rabat, dostępność, SKU/EAN, zdjęcie,
  // pasek sticky, etykieta przycisku i adres URL.
  var vScript=document.querySelector('[id^="ee-variants-"]');
  if(vScript){
    var variants=[];
    try{ variants=JSON.parse(vScript.textContent||'[]'); }catch(e){ variants=[]; }
    // mapa stanów magazynowych per wariant (id -> {qty, tracked})
    var stockMap={};
    var sScript=document.querySelector('[id^="ee-stock-"]');
    if(sScript){ try{ stockMap=JSON.parse(sScript.textContent||'{}'); }catch(e){ stockMap={}; } }
    var LOW_STOCK_THRESHOLD=5;
    var selects=Array.prototype.slice.call(document.querySelectorAll('.variant__select'));

    function setText(id,txt){ var el=document.getElementById(id); if(el) el.textContent=txt; }
    function setHtml(id,html){ var el=document.getElementById(id); if(el) el.innerHTML=html; }
    function setHidden(id,hide){
      var el=document.getElementById(id); if(!el) return;
      if(hide) el.setAttribute('hidden',''); else el.removeAttribute('hidden');
    }

    function applyVariant(v){
      if(!v) return;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;

      // id wariantu w formularzu
      var idInput=document.getElementById('ee-variant-id');
      if(idInput) idInput.value=v.id;

      // ceny
      setHtml('ee-price', eeFormatMoney(v.price));
      setHtml('ee-sticky-price', eeFormatMoney(v.price));
      if(onSale){
        setHtml('ee-price-old', eeFormatMoney(v.compare_at_price));
        setHtml('ee-sticky-old', eeFormatMoney(v.compare_at_price));
      }
      setHidden('ee-price-old', !onSale);
      setHidden('ee-sticky-old', !onSale);

      // etykieta rabatu (szablon tłumaczenia z data-tpl, __PCT__ → procent)
      ['ee-save-badge','ee-promo-save'].forEach(function(id){
        var el=document.getElementById(id);
        if(!el) return;
        if(onSale){
          var tpl=el.getAttribute('data-tpl')||'-__PCT__%';
          el.textContent=tpl.replace('__PCT__', pct);
          el.removeAttribute('hidden');
        }else{
          el.setAttribute('hidden','');
        }
      });

      // Omnibus: najniższa cena z 30 dni dla wybranego wariantu
      var omniEl=document.getElementById('ee-omnibus');
      if(omniEl){
        if(!window.__eeLowest){
          window.__eeLowest={};
          var lowScript=document.querySelector('[id^="ee-lowest-"]');
          try{ if(lowScript) window.__eeLowest=JSON.parse(lowScript.textContent||'{}'); }catch(e){}
        }
        var low=+window.__eeLowest[String(v.id)]||0;
        if(!low && onSale) low=v.compare_at_price||0;
        if(onSale && low>0){
          setText('ee-omnibus-val', eeFormatMoney(low));
          omniEl.removeAttribute('hidden');
        }else{
          omniEl.setAttribute('hidden','');
        }
      }

      // timer promocji: pokazuj tylko gdy bieżący wariant jest przeceniony
      eeSaleState.onSale=!!onSale;
      if(typeof window.eeRefreshCycle==='function') window.eeRefreshCycle();

      // dostępność + wskaźnik niskiego stanu (≤5 sztuk, gdy wariant śledzi zapasy)
      var avail=document.getElementById('ee-avail');
      var dot=document.getElementById('ee-avail-dot');
      if(avail){
        var availText;
        if(!v.available){
          availText=avail.getAttribute('data-out')||'';
          avail.classList.remove('avail--low');
        }else{
          var st=stockMap[String(v.id)];
          var isLow=st && st.tracked && st.qty>0 && st.qty<=LOW_STOCK_THRESHOLD;
          if(isLow){
            var tpl=avail.getAttribute('data-low-tpl')||'Only __QTY__ left';
            availText=tpl.replace('__QTY__', st.qty);
            avail.classList.add('avail--low');
          }else{
            availText=avail.getAttribute('data-in')||'';
            avail.classList.remove('avail--low');
          }
        }
        setText('ee-avail-text', availText);
      }
      if(dot) dot.classList.toggle('dot--out', !v.available);

      // SKU / EAN
      setText('ee-sku', v.sku||'');
      setHidden('ee-sku-wrap', !v.sku);
      setText('ee-ean', v.barcode||'');
      setHidden('ee-ean-wrap', !v.barcode);

      // przycisk: stan + etykieta
      var btn=document.getElementById('ee-add'), lab=document.getElementById('ee-add-label');
      if(btn) btn.disabled=!v.available;
      if(lab) lab.textContent = v.available ? (lab.getAttribute('data-add')||lab.textContent)
                                            : (lab.getAttribute('data-out')||lab.textContent);

      // "Kup teraz" (payment_button): wyszarz przy niedostępnym wariancie
      var dynCheckout=document.getElementById('ee-dynamic-checkout');
      if(dynCheckout) dynCheckout.classList.toggle('ee-dynamic-checkout--disabled', !v.available);

      // Wersja A: przy niedostępnym wariancie ukryj "Out of stock" i "Kup teraz",
      // zostaw miejsce dla przycisku "Powiadom mnie" (aplikacja) obok ilości.
      var buyrow=document.getElementById('ee-buyrow');
      if(buyrow) buyrow.classList.toggle('buyrow--oos', !v.available);

      // sticky add-to-cart: ukryj przy niedostępnym wariancie (nie ma czego dodać)
      var stickyBar=document.getElementById('ee-sticky');
      if(stickyBar) stickyBar.classList.toggle('sticky-cart--oos', !v.available);

      // zdjęcie wariantu
      var pos = v.featured_media && v.featured_media.position ? v.featured_media.position
              : (v.featured_image && v.featured_image.position ? v.featured_image.position : null);
      if(pos && typeof window.eeGalleryGoTo==='function') window.eeGalleryGoTo(pos-1);

      // adres URL — żeby dało się wysłać link do konkretnego wariantu
      if(window.history && history.replaceState){
        try{
          var url=new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }catch(e){}
      }
    }

    if(selects.length){
      selects.forEach(function(s){
        s.addEventListener('change',function(){
          // wartość każdej opcji czytana po jej indeksie
          var chosen=[];
          selects.forEach(function(x){
            var i=parseInt(x.getAttribute('data-option-index'),10);
            if(isNaN(i)) i=selects.indexOf(x);
            chosen[i]=x.value;
          });
          var v=variants.find(function(vr){
            if(!vr.options) return false;
            for(var i=0;i<chosen.length;i++){
              if(chosen[i]!=null && vr.options[i]!==chosen[i]) return false;
            }
            return true;
          });
          applyVariant(v);
        });
      });
    }
  }

  // ===== PASEK DARMOWEJ WYSYŁKI =====
  // próg bierzemy z sekcji koszyka (jedno źródło prawdy). Tekst może zawierać %amount%.
  (function(){
    var bar=document.getElementById('ee-freeship');
    if(!bar) return;
    var tpl=bar.getAttribute('data-tpl')||'';
    if(tpl.indexOf('%amount%')===-1) return; // stały tekst — nic nie robimy
    function fill(){
      var cfg=window.EE_CART_DRAWER;
      if(!cfg || !cfg.thresholdCents || cfg.thresholdCents<=0){ bar.setAttribute('hidden',''); return; }
      var txt=document.getElementById('ee-freeship-text');
      if(txt) txt.innerHTML=tpl.replace('%amount%', eeFormatMoney(cfg.thresholdCents, cfg.moneyFormat));
      bar.removeAttribute('hidden');
    }
    fill();
    document.addEventListener('ee:cart-drawer-ready', fill);
  })();

  // ===== OPIS PRODUKTU — DESKTOP: rozwijanie natywnego .rte motywu =====
  // Na desktopie motyw renderuje opis jako pełnoszeroką sekcję (.rte) poza naszą kartą.
  // Znajdujemy ten element i owijamy go w kontener z max-height + fade + przycisk toggle.
  // Na mobilce nic nie robimy (opis jest w akordeonie).
  (function(){
    if(window.matchMedia('(max-width:880px)').matches) return; // mobilka → akordeon

    var descSnip=(window.EE_DESC_SNIP||'').trim();
    if(!descSnip) return;

    function findRte(){
      var sec=document.getElementById('ee-product-section');
      if(!sec) return null;
      var candidates=document.querySelectorAll('.rte, .product-description, .product__description');
      for(var i=0;i<candidates.length;i++){
        var el=candidates[i];
        if(sec.contains(el)) continue; // pomiń .rte WEWNĄTRZ naszej sekcji (taby)
        if((el.textContent||'').indexOf(descSnip)!==-1) return el;
      }
      return null;
    }

    function wrapRte(rte){
      if(rte.dataset.eeDescWrapped) return;
      rte.dataset.eeDescWrapped='1';

      var MAX_H=320;
      // sprawdź czy treść jest dłuższa niż max-height — jeśli nie, nie robimy nic
      // (potrzebujemy tymczasowo zmierzyć, a rte może być jeszcze w budowie)
      function needsCollapse(){ return rte.scrollHeight > MAX_H + 20; }

      if(!needsCollapse()){
        // poczekaj chwilę (obrazki mogą się doładować i zwiększyć wysokość)
        setTimeout(function(){ if(needsCollapse()) applyCollapse(); },500);
        return;
      }
      applyCollapse();

      function applyCollapse(){
        // owijamy rte w kontener z ograniczoną wysokością
        var wrapper=document.createElement('div');
        wrapper.className='ee-desc-wrap';
        rte.parentNode.insertBefore(wrapper,rte);
        wrapper.appendChild(rte);

        // fade na dole
        var fade=document.createElement('div');
        fade.className='ee-desc-wrap__fade';
        wrapper.appendChild(fade);

        // przycisk toggle
        var lMore=document.getElementById('ee-product-section');
        var moreText=(lMore&&lMore.getAttribute('data-desc-more'))||'Expand description';
        var lessText=(lMore&&lMore.getAttribute('data-desc-less'))||'Collapse description';

        var btn=document.createElement('button');
        btn.className='ee-desc-wrap__toggle';
        btn.innerHTML='<span>'+moreText+'</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
        wrapper.parentNode.insertBefore(btn,wrapper.nextSibling);

        // ustawiam max-height
        wrapper.style.maxHeight=MAX_H+'px';
        wrapper.style.overflow='hidden';
        wrapper.style.position='relative';
        wrapper.style.transition='max-height .4s ease';

        var expanded=false;
        btn.addEventListener('click',function(){
          expanded=!expanded;
          wrapper.style.maxHeight=expanded?'none':MAX_H+'px';
          wrapper.style.overflow=expanded?'visible':'hidden';
          fade.style.opacity=expanded?'0':'1';
          btn.classList.toggle('is-expanded',expanded);
          var span=btn.querySelector('span');
          if(span) span.textContent=expanded?lessText:moreText;
          if(!expanded) wrapper.scrollIntoView({behavior:'smooth',block:'start'});
        });
      }
    }

    function run(){
      var rte=findRte();
      if(rte) wrapRte(rte);
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
    else run();
    setTimeout(run,800); // fallback na dynamicznie ładowany opis
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
